
<template>
  <b-img v-if="false" src="https://picsum.photos/300/180/?image=41" fluid-grow alt="Fluid-grow image" style="height: 180px"></b-img>
</template>
<script>

export default {
  name: 'MediaBanner',
  props: {

  },
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
